// src/pages/AvisoPrivacidad.jsx
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export default function AvisoPrivacidad() {
  return (
    <section className="min-h-screen py-28 md:py-40 px-6 lg:px-10 bg-background">
      <div className="max-w-4xl mx-auto">
        {/* Volver */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-10 text-sm font-light"
        >
          <ArrowLeft size={16} /> Volver al inicio
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-serif-display text-4xl md:text-5xl font-light text-foreground mb-4">
            Aviso de Privacidad
          </h1>
          <p className="text-sm text-muted-foreground font-light mb-12">
            Última actualización: agosto de 2026
          </p>

          <div className="space-y-8 text-foreground/80 font-light leading-relaxed">
            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                1. Responsable del Tratamiento
              </h2>
              <p className="mb-2">
                Casa El Gavillero (en adelante, "el Responsable") es el responsable
                del tratamiento de sus datos personales, con domicilio en:
              </p>
              <p className="text-sm bg-secondary/30 p-4 rounded-sm border border-border">
                Fresnos No.64 Colonia el Sauz, Tequisquiapan, Querétaro CP 76796
              </p>
              <p className="mt-2">
                Para cualquier asunto relacionado con el tratamiento de sus datos,
                puede contactarnos en:
              </p>
              <p className="text-sm bg-secondary/30 p-4 rounded-sm border border-border">
                ✉️ reservaciones@casaelgavillero.com.mx
              </p>
            </section>

            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                2. Datos Personales Recabados
              </h2>
              <p className="mb-4">
                Para las finalidades descritas en este Aviso, podemos recabar los
                siguientes datos personales:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-sm">
                <li>Nombre completo</li>
                <li>Dirección de correo electrónico</li>
                <li>Número de teléfono</li>
                <li>Domicilio particular</li>
                <li>Fecha de nacimiento</li>
                <li>Información sobre sus preferencias y necesidades de hospedaje</li>
                <li>Datos de pago y facturación (cuando realice una reserva)</li>
              </ul>
              <p className="mt-4 text-sm text-muted-foreground">
                No recabamos datos personales sensibles salvo que sea estrictamente
                necesario para la prestación de nuestros servicios.
              </p>
            </section>

            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                3. Finalidades del Tratamiento
              </h2>
              <p className="mb-4">
                Sus datos personales serán utilizados para las siguientes finalidades:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-sm">
                <li>Gestionar y procesar sus reservaciones</li>
                <li>Responder a sus consultas y solicitudes de información</li>
                <li>Enviar comunicaciones relacionadas con su estancia</li>
                <li>Mejorar nuestros servicios y atención al cliente</li>
                <li>Cumplir con obligaciones legales y fiscales</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                4. Transferencia de Datos
              </h2>
              <p>
                Sus datos personales no serán transferidos a terceros salvo cuando
                sea necesario para cumplir con obligaciones legales, o cuando usted
                haya otorgado su consentimiento expreso para ello. En caso de
                transferencias, se garantizará la confidencialidad y seguridad de
                sus datos.
              </p>
            </section>

            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                5. Derechos ARCO
              </h2>
              <p className="mb-4">
                Usted tiene derecho a ejercer sus derechos de Acceso, Rectificación,
                Cancelación y Oposición (derechos ARCO) en relación con el
                tratamiento de sus datos personales [citation:11][citation:9].
              </p>
              <ul className="list-disc pl-6 space-y-2 text-sm">
                <li>
                  <strong>Acceso:</strong> Conocer qué datos tenemos sobre usted y
                  cómo los usamos.
                </li>
                <li>
                  <strong>Rectificación:</strong> Solicitar la corrección de sus
                  datos si están desactualizados o son incorrectos.
                </li>
                <li>
                  <strong>Cancelación:</strong> Solicitar la eliminación de sus
                  datos de nuestros registros.
                </li>
                <li>
                  <strong>Oposición:</strong> Oponerse al uso de sus datos para
                  fines específicos.
                </li>
              </ul>
              <p className="mt-4 text-sm bg-secondary/30 p-4 rounded-sm border border-border">
                Para ejercer sus derechos ARCO, envíe su solicitud a:
                <br />
                ✉️ reservaciones@casaelgavillero.com.mx
                <br />
                <span className="text-muted-foreground text-xs">
                  Su solicitud deberá incluir: nombre completo, domicilio, correo
                  electrónico y una descripción clara del derecho que desea ejercer.
                </span>
              </p>
            </section>

            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                6. Uso de Cookies
              </h2>
              <p>
                Nuestro sitio web utiliza cookies para mejorar su experiencia de
                navegación y analizar el tráfico del sitio. Las cookies son
                archivos de texto que se almacenan en su dispositivo y nos ayudan
                a reconocerlo en visitas futuras [citation:9].
              </p>
              <p className="mt-2">
                Usted puede configurar su navegador para rechazar o eliminar las
                cookies en cualquier momento. Sin embargo, esto podría afectar el
                funcionamiento de algunas funcionalidades del sitio.
              </p>
            </section>

            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                7. Cambios al Aviso de Privacidad
              </h2>
              <p>
                Este Aviso de Privacidad puede ser actualizado periódicamente. Le
                recomendamos revisar esta página con regularidad para mantenerse
                informado sobre cómo protegemos su información [citation:9].
              </p>
            </section>

            <div className="border-t border-border pt-8 mt-8 text-sm text-muted-foreground">
              <p>
                Este Aviso de Privacidad se rige por la Ley Federal de Protección
                de Datos Personales en Posesión de los Particulares (LFPDPPP) y su
                Reglamento [citation:11][citation:9].
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}